import { type UseQueryResult, useQuery } from 'react-query';
import { ResidenceStatusService } from '../../services/wealthlane-customer-services';

const useGetResidentOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
      isUsCitizen: boolean;
      isUsResidentAlien: boolean;
    }>
  | undefined,
  unknown
> => {
  const CustomerResidenceStatusList = useQuery(
    ['getCustomerResidenceStatusList'],
    async () => {
      return await handleRequest(
        ResidenceStatusService.getApiCustomerApiAppResidenceStatusResidenceStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
            isUsCitizen: item.isUsCitizen ?? false,
            isUsResidentAlien: item.isUsResidentAlien ?? false,
          };
        });
      },
    }
  );

  return CustomerResidenceStatusList;
};

export default useGetResidentOptions;
